<ion-card class="card-common-blue ion-no-margin ion-margin-top">

  <ion-card-header>

    <!-- Back navigation title with dynamic service provider title -->
    <ion-card-title (click)="backBtnClicked()" (keydown.enter)="backBtnClicked()" class="cursor-pointer">
      <ion-icon src="assets/imgs/left-chevron.svg" class="iconPadding font24"></ion-icon>

      <ion-text class="ion-margin-start">
        @if(isCallHolman())
        {
        {{'CALL_HOLMAN' | translate}}
        } @else {
        {{ serviceProviderData()?.sC_SERVICE_TITLE ?? '--' }}
        }
      </ion-text>
    </ion-card-title>

  </ion-card-header>

  <ion-card-content class="ion-margin-top">

    <!-- Render provider details when available -->
    @if (providerDetails()) {

    <!-- Provider description section (shown only if description exists) -->
    @if (providerDetails()?.provideR_DESCRIPTION) {
    <ion-row>
      <ion-col class="ion-no-padding primary-color font-md" size="12">
        <ion-text>
          {{providerDetails()?.provideR_DESCRIPTION ?? '--'}}
        </ion-text>
      </ion-col>
    </ion-row>
    }

    <!-- Provider logo section (shown only if logo exists) -->
    @if (providerDetails()?.provideR_LOGO) {
    <ion-row class="ion-margin ion-padding">
      <ion-col class="d-flex justify-content-center" size="12">
        <img class="imgClass"
          src="{{getImageUrl(providerDetails()?.provideR_LOGO ?? '', providerDetails()?.provideR_LOGO_MIMETYPE ?? '')}}"
          alt="Loaded Image" />
      </ion-col>
    </ion-row>
    }

    <!-- Contact action buttons (website / phone) -->
    @if(contactDetails() && contactDetailsCount())
    {
    @for (contact of sortedContactDetails(); track $index) {
    <ion-row class="ion-justify-content-center">

      <!-- Website contact action -->
      @if(contact.contacT_TYPE_KEY=='WEBSITE'){
      <ion-col size-xl="4" size-lg="4" size-md="5" size-xs="12" size-sm="12" class="ion-text-center">
        <ion-button class="ion-text-capitalize btn_secondary" (click)="handleActionButton(contact)" expand="block"
          fill="solid">
          {{contact.caption}}
        </ion-button>
      </ion-col>
      }

      <!-- Email contact action -->
      @if(contact.contacT_TYPE_KEY=='EMAIL'){
      <ion-col size-xl="4" size-lg="4" size-md="5" size-xs="12" size-sm="12" class="ion-text-center">
        <ion-button class="ion-text-capitalize btn_secondary" (click)="openMail(contact.contacT_VALUE)" expand="block"
          fill="solid">
          {{contact.caption}}
        </ion-button>
      </ion-col>
      }

      <!-- Phone contact action -->
      @if(contact.contacT_TYPE_KEY=='PHONE'){
      <ion-col size-xl="4" size-lg="4" size-md="5" size-xs="12" size-sm="12" class="ion-text-center">
        <ion-button class="ion-text-capitalize btn_secondary_outline" expand="block"
          (click)="callHolman(contact.contacT_VALUE)">
          {{contact.caption}} {{!isMobileApp()? contact.contacT_VALUE : ''}}
        </ion-button>
      </ion-col>
      }

    </ion-row>
    }
    }

    }

    <!-- Fallback message when provider details are not available -->
    @if (!providerDetails()) {
    <ion-row>
      <ion-col class="d-flex justify-content-center ion-no-padding" size="12">
        <ion-text>
          {{'MSG18' | translate}}
        </ion-text>
      </ion-col>
    </ion-row>
    }

  </ion-card-content>

</ion-card>